import React from "react";
import styled from "styled-components";
import { StaticImage } from "gatsby-plugin-image";
import { Link } from "gatsby";

import Facebook from "../Icons/FacebookIcon";
import Instagram from "../Icons/InstagramIcon";
import Youtube from "../Icons/YoutubeIcon";
import Pinterest from "../Icons/PinterestIcon";
import PrimaryButton from "../Button/PrimaryButton";
import PhoneIcon from "../Icons/PhoneIcon";
import { Container } from "../Section";

const FooterWrap = styled.div`
  position: relative;
  padding: 20px 0 60px;
  @media (min-width: 768px) {
    padding: 20px 0;
  }
  @media (min-width: 992px) {
    padding: 220px 0 20px;
  }
  .container {
    position: relative;
    z-index: 1;
  }
`;
const FooterBg = styled.div`
  position: absolute;
  z-index: 0;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;

  .gatsby-image-wrapper {
    width: 100%;
    height: 100%;
  }
`;
const MenuGrid = styled.div`
  position: relative;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin: 0 -10px;
  border-bottom: 1px dashed #938888;
`;
const MenuItemGrid = styled.div`
  position: relative;
  width: 100%;
  padding: 0 10px;
  &.menu-item {
    flex: 0 0 50%;
    max-width: 50%;
    &:first-child {
      @media (min-width: 576px) {
        flex: 0 0 auto;
        width: auto;
        max-width: 100%;
      }
    }
    @media (min-width: 992px) {
      flex: 0 0 25%;
      max-width: 25%;
      + .menu-item {
        flex: 0 0 auto;
        width: auto;
        max-width: 100%;
      }
    }
  }
`;
const MenuTitle = styled.div`
  position: relative;
  font-weight: 700;
  color: #fff;
  margin-bottom: 10px;
  padding-bottom: 10px;
  font-size: 16px;
  line-height: 26px;
  @media (min-width: 576px) {
    font-size: 20px;
    line-height: 30px;
  }
  &:after{
    content:'';
    position:absolute;
    bottom:0;
    left:0;
    width:50px;
    border-bottom:2px solid #D7272C;

  }
`;

const MenuList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0 0 30px;
  color: #d0d0d0;
  font-size: 14px;
  line-height: 24px;
  @media (min-width: 576px) {
    font-size: 16px;
    line-height: 30px;
  }
`;
const MenuItem = styled.li`
  margin: 0;
  padding: 0;
  + li {
    margin-top: 5px;
  }
  & a {
    display: inline-block;
    color: #d0d0d0;
    position: relative;
    &:hover {
      color: #fff;
    }
  }
`;

const SocialMedia = styled.div`
  display: flex;
  flex-wrap:wrap;
  align-items: center;
  margin:0 -5px 20px -5px;
  a {
    margin: 0px 5px;
    width: 30px;
    height: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: rgba(255, 255, 255, 0.3);
    border-radius: 4px;
    &:hover{
      background: #D7272C;
    }
  }
`;
const FooterBottom = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  text-align: center;
  margin-top: 20px;
  font-size: 12px;
  line-height: 24px;
  @media (min-width: 576px) {
    font-size: 14px;
    line-height: 24px;
  }
  @media (min-width: 768px) {
    justify-content: space-between;
    text-align: left;
  }
`;
const CopyRight = styled.div`
  position: relative;
  width: 100%;
  color: #fff;
  text-transform: uppercase;
  @media (min-width: 768px) {
    flex-basis: 0px;
    flex-grow: 1;
    max-width: 100%;
  }
`;
const FooterNav = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin: 0 -12px;
  @media (min-width: 768px) {
    flex: 0 0 auto;
    width: auto;
    max-width: none;
    justify-content: flex-end;
  }
`;
const FooterItemNav = styled.div`
  position: relative;
  padding: 0 12px;
  &.footer-item {
    + .footer-item {
      &:before {
        content: "";
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        width: 4px;
        height: 4px;
        border-radius: 50%;
        margin-left: -14px;
        background-color: #fff;
      }
    }
  }
  > a {
    color: #d0d0d0;
    &:hover,
    &:focus {
      color: #fff;
    }
  }
`;
const FooterCta = styled.div`
  background-color: #fff;
  box-shadow: 0px -5px 25px 0px rgb(0 75 155 / 25%);
  width: 100%;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 99;
  text-align: center;
  display: block;
  @media (min-width: 768px) {
    display: none;
  }
  a {
    display: block;
  }
  .btn {
    display: flex;
    border-radius:0;
  }
`;
const BbbLogo = styled.div`

`;

const Footer = ({ location }) => {
  return (
    <FooterWrap>
      <FooterBg><StaticImage src="../../images/footer-bg.png" placeholder="blurred" alt="footer background"/></FooterBg>
      <Container>
        <MenuGrid className="menu-grid">
          <MenuItemGrid className="menu-item">
            <MenuTitle>Home</MenuTitle>
            <MenuList>    
              <MenuItem><Link to="/portable-buildings">Portable Buildings</Link></MenuItem>
              <MenuItem><Link to="/steel-buildings">Steel Buildings</Link></MenuItem>
              <MenuItem><Link to="/red-iron-buildings">Red Iron Buildings</Link></MenuItem>
              <MenuItem><Link to="/pole-barns">Pole Barns</Link></MenuItem>
              <MenuItem><Link to="/gazebos">Gazebos</Link></MenuItem>
              <MenuItem><Link to="/greenhouses">Greenhouses</Link></MenuItem>
              <MenuItem><Link to="/screen-rooms">Screen rooms</Link></MenuItem>
            </MenuList>
          </MenuItemGrid>

          <MenuItemGrid className="menu-item">
            <MenuTitle>Resources</MenuTitle>
            <MenuList>
              <MenuItem><Link to="/financing">Financing</Link></MenuItem>
              <MenuItem><Link to="/rto">Rent to Own</Link></MenuItem>
              <MenuItem><Link to="/faq">FAQs</Link></MenuItem>
              <MenuItem><Link to="/gallery">Gallery</Link></MenuItem>
              <MenuItem><Link to="/blog">Blogs</Link></MenuItem>
              <MenuItem><Link to="/reviews">Reviews</Link></MenuItem>
            </MenuList>
          </MenuItemGrid>

          <MenuItemGrid className="menu-item">
            <MenuTitle>Company</MenuTitle>
            <MenuList>
              <MenuItem><Link to="/about-us">About Us</Link></MenuItem>
              <MenuItem><Link to="/help-and-info">Help and Info</Link></MenuItem>
              <MenuItem><Link to="/service-area">Service Area</Link></MenuItem>
              <MenuItem><Link to="/contact">Contact Us</Link></MenuItem>
            </MenuList>
          </MenuItemGrid>

          <MenuItemGrid className="menu-item">
            <MenuTitle>Social Media</MenuTitle>
            <SocialMedia>
              <a href="https://www.facebook.com/BuildingsAndMore/?fref=ts" target="_blank" aria-label="facebook" rel="noreferrer"><Facebook fill="#fff" /></a>
              <a href="https://www.youtube.com/channel/UC4gVU1Ei9nbWT6yNmYllSQQ" target="_blank" aria-label="youtube" rel="noreferrer"><Youtube fill="#fff" /></a>
              <a href="https://www.instagram.com/buildingsandmorefl/" className="instagram" target="_blank" aria-label="instagram" rel="noreferrer"><Instagram fill="#fff" /></a>
              <a href="https://www.pinterest.com/buildingsandmore/" className="pinterest" target="_blank" aria-label="pinterest" rel="noreferrer"><Pinterest fill="#fff" /></a>
            </SocialMedia>
            <BbbLogo>
              <a href="https://www.bbb.org/us/fl/lake-city/profile/portable-buildings/buildings-more-0403-1124279" target="_blank" rel="noreferrer"><StaticImage src="../../images/accreditation.png" placeholder="blurred" alt="BBB accredited business" /></a>
            </BbbLogo>
          </MenuItemGrid>
        </MenuGrid>
        <FooterBottom>
          <CopyRight>© {new Date().getFullYear()} Buildings And More &nbsp; | &nbsp; All Rights Reserved.</CopyRight>
          <FooterNav>
            <FooterItemNav className="footer-item"><Link to="/privacy-policy">Privacy Policy</Link></FooterItemNav>
            <FooterItemNav className="footer-item"><Link to="/terms-and-conditions">Terms of Use</Link></FooterItemNav>
          </FooterNav>
        </FooterBottom>
      </Container>
      <FooterCta className="footer-cta"><a href="tel:3867556449"><PrimaryButton textAfter="(386) 755 6449" icon={<PhoneIcon />} /></a></FooterCta>
    </FooterWrap>
  );
};
export default Footer;
